import ProjectSessionCollection from "../collection";
import ProjectSession from "../project-session";

// const debug = "itemsCollection_initTree"
const debug = false

export default function projectSessionCollection_initTree(projectSessionCollection:ProjectSessionCollection) {

    debug && console.log("init Tree root")

    // reset(clear) tree children
    projectSessionCollection.clearTree()

    _.map(projectSessionCollection.models, (project: ProjectSession)=>{
        project.initTree(projectSessionCollection)
    })

    // projectSessionCollection.debugTreeRoots()
}